/**
 * Module dependencies.
 */

import { Container as DefaultContainer, media } from '@untile/react-components';
import { theme } from 'styled-tools';
import styled from 'styled-components';

/**
 * `Container` component.
 */

const Container = styled(DefaultContainer)`
  padding: 0 ${theme('grid.gutterMobile')}px;

  ${media.min('lg')`
    padding: 0;
  `}
`;

/**
 * Export `Container` component.
 */

export default Container;
